import { TAG_FIELDS } from '@/graphql/fragments/tags';
import { gql } from '@apollo/client';

export const QUERY_ADMIN_TAGS = gql`
    ${TAG_FIELDS}
    query GetAdminTags {
        results: tags(
            where: {
                _and: [
                    { client_id: { _is_null: true } }
                    { organization_id: { _is_null: true } }
                    { accessorial_tag: { _eq: true } }
                ]
            }
        ) {
            ...TagFields
        }
    }
`;

export const UPSERT_TAGS = gql`
    ${TAG_FIELDS}
    mutation UpsertTag($tags: [tags_insert_input!]!) {
        created: insert_tags(
            objects: $tags
            on_conflict: { constraint: tags_pkey, update_columns: [tag, item_tag, accessorial_tag] }
        ) {
            returning {
                ...TagFields
            }
        }
    }
`;

export const DELETE_TAG = gql`
    ${TAG_FIELDS}
    mutation DeleteTag($tag_id: uuid!) {
        removed: delete_tags(where: { tag_id: { _eq: $tag_id } }) {
            returning {
                ...TagFields
            }
        }
    }
`;
